import { AuthProvider } from "@redotech/redo-customer-portal-app/contexts/auth";
import { CurrencyExchangeProvider } from "@redotech/redo-customer-portal-app/contexts/currency-exchange";
import { CustomerContextProvider } from "@redotech/redo-customer-portal-app/contexts/CustomerContext";
import { FlowElementTextOverlayProvider } from "@redotech/redo-customer-portal-app/contexts/flow-element-text-overlay";
import { RpcClientContextProvider } from "@redotech/redo-customer-portal-app/contexts/RpcClientContext";
import { SettingsProvider } from "@redotech/redo-customer-portal-app/contexts/settings";
import { UserContextProvider } from "@redotech/redo-customer-portal-app/contexts/user";
import {
  CustomizationApplicationProvider,
  CustomizationProvider,
  routeDisablesPortalCustomization,
} from "@redotech/redo-customer-portal-app/customization/customization-context";
import { ReferralProvider } from "@redotech/redo-customer-portal-shared/contexts/referral";
import { CustomSnackbarProvider } from "@redotech/redo-web/snackbar";
import { memo } from "react";
import { Outlet, useMatches } from "react-router-dom";

export const Root = memo(function Root() {
  const shouldApplyCustomization = !useMatches().some((match) =>
    routeDisablesPortalCustomization(match.handle),
  );

  return (
    <SettingsProvider>
      <AuthProvider>
        <RpcClientContextProvider>
          <FlowElementTextOverlayProvider>
            <CustomizationApplicationProvider
              shouldApplyCustomization={shouldApplyCustomization}
            >
              <CustomizationProvider>
                <CurrencyExchangeProvider>
                  <UserContextProvider>
                    <CustomerContextProvider>
                      <ReferralProvider>
                        <CustomSnackbarProvider>
                          <Outlet />
                        </CustomSnackbarProvider>
                      </ReferralProvider>
                    </CustomerContextProvider>
                  </UserContextProvider>
                </CurrencyExchangeProvider>
              </CustomizationProvider>
            </CustomizationApplicationProvider>
          </FlowElementTextOverlayProvider>
        </RpcClientContextProvider>
      </AuthProvider>
    </SettingsProvider>
  );
});
